<app-main-input-form
  (updateData)="onUpdate($event)"
  [applyPhoneMask]="true"
  [disabled]="disabled()"
  [hasPrefix]="true"
  [isRequired]="false"
  [phoneMask]="phoneMask()"
  [phoneMaskExpression]="phoneMaskExpression()"
  [placeholder]="phoneMask()"
  [value]="client().tags['phoneNumber']"
  controlName="phoneNumber"
  formItemType="text"
  label="Phone Number"
  sizeClass="w-[216px]"
>
  <avs-country-select
    class="mr-2"
    (changed)="onCountryCodeChange($event)"
    [showPhoneCode]="true"
    [value]="client().tags['countryCode'] || DEFAULT_COUNTRY.code"
  />
</app-main-input-form>
